<template>
<div style="width:1300px;margin:0 auto;padding:80px 0 0px 0;margin-bottom:60px;position:relative;color:#272a36">
  <div class="titleStyle" :style="titleStyle">
    <span style="font-size:97px;font-weight:700">{{title}}</span>
  </div>
  <img src="@/views/solution/images/redRight.png" alt="" srcset="" style="width:23px;position:absolute;top:35px;left:505px">
  <div style="position:absolute;display:block;bottom:0px;font-size:18px;letter-spacing:1px;font-weight:300;left:505px;border-bottom:1px solid #3f4354;padding-bottom:5px;width:770px;">
    <span style="color:#272a36;">{{subTitle}}</span>
  </div>
</div>
</template>
<script>
export default {
  name: 'App',
   components:{
 
  },
  props: {
    titleStyle: {
      type: String,
      default: ''
    },
    subTitleStyle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Equipment'
    },
    subTitle: {
      type: String,
      default: '生产设备'
    }
  },
  data() {  
    return {  
     images: [  
       
      ] 
    };  
  }, 

  methods:{
    
  }
}
</script>
<style lang="scss" scoped>
.titleStyle {
  height:100%;display:inline-block;width:390px;
}
.subTitleStyle {
  position:relative;display:inline-block;width:910px;height:95px;border-bottom:1px solid #000;
}
</style>
